import { createReducer } from "@reduxjs/toolkit";
import { searchFetch } from "../search/actions";
export var initialState = {};
export var reducer = createReducer(initialState, function (builder) {
  return builder.addCase(searchFetch.fulfilled, function (_, action) {
    return action.payload.searchConfig;
  });
});